import React,{Component} from 'react';
import Select from '@react/react-spectrum/Select';
import i18n from '../../i18n';
import axios from "axios/index";
import _ from 'lodash';
import {connect} from "react-redux";
import {setUserLocale,setAvailableLocale,setGlobalNavLocale,setUserLanguageLocale} from '../../actions/LocaleActions';
import moment from 'moment';
import 'moment/min/locales';

class SelectLanguage extends Component{
    constructor(props){
        super(props);
        this.selectedLocale = {};
        this.setLocale();
    }

    checkLangCodeQueryString(){
        if(window.location.href.indexOf('lang') > -1){
            var queryParams = this.getHashParamByName('lang');
            if(queryParams && this.props.availableLocales && this.props.availableLocales.length){
                var langObj = _.find(this.props.availableLocales,function (obj) {
                    return obj.value === queryParams
                });
                if(langObj){
                    return langObj;
                }else{
                    return '';
                }
            }
        }else{
            return '';
        }
    }

    getHashParamByName(key) {
        if (typeof key !== 'string') {
             key = '';
         } else {
             key = key.toLowerCase();
         }
         var keyAndHash = window.location.hash.match(new RegExp(key + '=([^&]*)'));
         var value = '';
         if (keyAndHash) {
             value = keyAndHash[1];
         }
         return value;
    }


    setLocale(){
        var langCodeObj = this.checkLangCodeQueryString();
        if(langCodeObj && langCodeObj !== ''){
            this.selectedLocale = langCodeObj;
            i18n.changeLanguage(this.selectedLocale.langCode);
            this.setUserdetails(this.selectedLocale.value);
            if(this.selectedLocale.langCode && this.selectedLocale.langCode !== 'en') {
                moment().locale(this.selectedLocale.langCode);
            }
            let globalLocale;
            if(this.selectedLocale.langCode.indexOf("-") > -1){
                globalLocale = this.selectedLocale.value;
            }else{
                globalLocale = this.selectedLocale.langCode+'_'+this.selectedLocale.countryCode;
            }
            this.props.setAdobeGlobalNavLocale(globalLocale);
            localStorage.setItem('globalLocale', globalLocale);
        }
        else if(localStorage.getItem('userLang') && localStorage.getItem('userLang') !== undefined && localStorage.getItem('userLang') !== ''){
            if(this.props.availableLocales && this.props.availableLocales.length){
                this.selectedLocale = _.find(this.props.availableLocales,function (obj) {
                    return obj.value === localStorage.getItem('userLang')
                });
                i18n.changeLanguage(this.selectedLocale.langCode);
            }
            if(this.selectedLocale.langCode && this.selectedLocale.langCode !== 'en') {
                moment().locale(this.selectedLocale.langCode);
            }
        }else{
            i18n.changeLanguage('en');
        }
    }

    change(event){
        const paymentMiniAppOn =
            this.props.featureFlags &&
            this.props.featureFlags.indexOf("ENABLE_PAYMENT_MINI_APP") > -1;
        if (paymentMiniAppOn) {
            const localeObj = _.find(this.props.availableLocales, (obj) => obj.value === event);
            if (localeObj) {
                this.selectedLocale = localeObj;
            }
        }
        this.setUserdetails(event);
        var url = window.location.hash.split('/')[0] + '?lang=' + event;
        if (paymentMiniAppOn) {
            let hash = window.location.hash || '#';
            url = /[?&]lang=[^&]*/.test(hash)
                ? hash.replace(/([?&])lang=[^&]*/, '$1lang=' + event)
                : hash + (hash.indexOf('?') > -1 ? '&' : '?') + 'lang=' + event;
        }
        window.location.href = url;
        window.location.reload();
        this.setLocale();
    };

    setUserdetails(event){
        this.props.setUserInfoLocale(event);
        this.props.setUserLanguageLocale(this.selectedLocale.langCode);
        if(!_.isEmpty(this.props.userInfo) && _.has(this.props.userInfo,'countryCode')){
            let globalLocale;
            if(event.indexOf("_") > -1){
                globalLocale = event;
            }else{
                globalLocale = event+'_'+this.props.userInfo.countryCode;
            }
            this.props.setAdobeGlobalNavLocale(globalLocale);
            localStorage.setItem('globalLocale', globalLocale);
        }else{
            localStorage.setItem('globalLocale', 'en_US');
        }
        if(event){
            localStorage.setItem('userLang', event);
        }else{
            localStorage.setItem('userLang', 'en');
        }
    }

    componentDidMount() {
        axios.get(process.env.PUBLIC_URL+'/config.json')
            .then(res => {
                if(res && res.data && res.data.services){
                    if ((window.location.href.indexOf("stage") > -1) || (window.location.href.indexOf("localhost") > -1)) {
                    this.props.setUserAvailableLocale(res.data.services[0].locales);
                    }
                    else{
                    this.props.setUserAvailableLocale(res.data.services[1].locales);
                    }
                    this.setLocale();
                }
            })
            .catch(function (error) {
            });
    }

    render(){
        return(

            <Select
                onChange={this.change.bind(this)}
                options={this.props.availableLocales}
                closeOnSelect={true}
                value={this.props.value}
                quiet
                flexible
            />
        )
    }
}

const mapStateToProps = (state)=>{
    return{
        value:state.LocaleReducer.value,
        availableLocales:state.LocaleReducer.availableLocales,
        userInfo:state.AuthReducer.userInfo,
        featureFlags:state.AppReducer.featureFlags
    }
};


const mapDispatchToProps = (dispatch)=>{
    return{
        setUserInfoLocale:(locale)=>{dispatch(setUserLocale(locale))},
        setUserAvailableLocale:(locale)=>{dispatch(setAvailableLocale(locale))},
        setAdobeGlobalNavLocale:(locale)=>{dispatch(setGlobalNavLocale(locale))},
        setUserLanguageLocale:(langCode)=>{dispatch(setUserLanguageLocale(langCode))}
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(SelectLanguage);


